import React from "react";
import DownloadFormLink from "./DownloadFormLink";
import { getTrainingForm } from "../../services";
import { useAppSelector } from "../../../../../redux/store";
import { selectCurrentCustomerNumber } from "../../../../../redux/customer";
import { TrainingProgramForm } from "../../types";
import { IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { TeamMember } from "../../../../../types";
import { selectIsAdminOrOwner } from "../../../../../redux/user";

interface UploadedFormPropTypes {
  trainingProgramForm: TrainingProgramForm | null;
  handleDeleteClick: (id: number) => void;
  searchValue: string;
  teamMembersById: Map<number, TeamMember>;
}

const UploadedForm = (props: UploadedFormPropTypes) => {
  const {
    trainingProgramForm,
    handleDeleteClick,
    searchValue,
    teamMembersById,
  } = props;

  const isAdminOrOwner = useAppSelector(selectIsAdminOrOwner)
  const customerNumber = useAppSelector(selectCurrentCustomerNumber);
  
  const userId = trainingProgramForm?.user_id ?? 0
  const teamMember = teamMembersById.get(userId) ?? null

  const downloadLink = (
    <DownloadFormLink
      searchValue={searchValue}
      customerNumber={customerNumber}
      getFileHandler={getTrainingForm}
      trainingProgramForm={trainingProgramForm}
      teamMember={teamMember}
    />
  );

  return (
    <React.Fragment>
      { trainingProgramForm?.file_id ? downloadLink : '' }
      {isAdminOrOwner && trainingProgramForm?.file_id ?
        <IconButton
          aria-label="delete"
          sx={{
            color: '#50555b',
            height: '20px',
            width: '20px',
            marginLeft: '5px'
          }}
          onClick={() => handleDeleteClick(trainingProgramForm.id)}
        >
          <Delete fontSize="small"/>
        </IconButton>
      : null}
    </React.Fragment>
  )
}

export default UploadedForm